import { useState } from 'react';
import Head from "next/head";
import Image from "next/image"
import { useRouter } from 'next/router';
//import tnpscwebbanner from "../../assets/images/Tnpsc/TNUSRB-SI-Mock-Test-Web-Banner.jpg";
//import tnpscmobbanner from "../../assets/images/Tnpsc/TNUSRB-SI-Mock-Test-Mobile-Banner.jpg";
import { NewStudentForm } from './form';
//import { CalendarDays, FileText, Clock, AlarmClock } from "lucide-react";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import styles from "./si-mock.module.css";
import Link from "next/link";
import NewiconA from "../../assets/images/header/pdf-download1.png";
export default function MobileCheck() {
  const [mobile, setMobile] = useState('');
  const [studentType, setStudentType] = useState('check');
  const router = useRouter(); 
  const [isloading, setLoading] = useState(false);
  const [existingData, setExistingData] = useState(null);

  const PoliceCap = () => (
<svg width="60" height="60" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">

  {/* Main cap body - khaki */}
  <path
    d="M50 210C100 120 260 80 460 200C410 260 120 270 50 210Z"
    fill="#B29A6A"
    stroke="#6F5A33"
    strokeWidth="10"
  />

  {/* Top curve */}
  <path
    d="M80 190C170 120 330 120 430 190"
    stroke="#6F5A33"
    strokeWidth="12"
    fill="none"
  />

  {/* Orange strap */}
  <rect
    x="80"
    y="240"
    width="350"
    height="35"
    rx="15"
    fill="#E06A2C"
  />

  {/* Center badge background */}
  <circle cx="255" cy="230" r="48" fill="#C0C5C9" stroke="#2F2A1F" strokeWidth="7"/>

  {/* Ashoka emblem simplified */}
  <path
    d="M255 200 L245 230 L265 230 Z M248 240 H262 V265 H248 Z"
    fill="#2F2A1F"
  />

  {/* Badge ring */}
  <circle cx="255" cy="230" r="30" stroke="#2F2A1F" strokeWidth="5" fill="none"/>
</svg>
);

    const data = [
        { title: "Exam Date", value: "14th December 2025" },
        { title: "Paper", value: "General Studies – Objective Type" },
        { title: "Exam Time", value: "10:00 AM – 12:30 PM" },
        { title: "Reporting Time", value: "8:30 AM" },
    ];

  return (
    <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>State Level TNUSRB SI Mock Test 2025</title>
            <meta name="title" content="State Level TNUSRB SI Mock Test 2025" />
            <meta name="description" content="Prepare for the TNUSRB Sub-Inspector Exam 2025 with our free mock test. Attempt full-length tests, get instant results, and analyze your performance — only at Shankar IAS Academy." />
            <meta name="keywords" content="State Level TNUSRB SI mock test, TNUSRB SI  test, TNUSRB SI practice test, TNUSRB Sub Inspector exam, TNUSRB test 2025, TNUSRB SI model question paper, TNUSRB SI preparation, TNUSRB SI free test" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnusrb-si-mock-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="State Level TNUSRB SI Mock Test 2025" />
            <meta property="og:description" content="Prepare for the TNUSRB Sub-Inspector Exam 2025 with our free mock test. Attempt full-length tests, get instant results, and analyze your performance — only at Shankar IAS Academy." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnusrb-si-mock-test/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="sch-test" />
      
      <div className="container p-3">
          <h1 className={`${styles.contactheader} pt-2 `}>
             State Level TNUSRB SI Mock Test 2025.
          </h1>
      {/* <div className='row pt-2 d-none d-md-block'>
        <div className='col'>
            <Image src={tnpscwebbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"/>
        </div>
    </div> 
    <div className='row pt-2 d-block d-md-none'>
        <div className='col'>
          <Image src={tnpscmobbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"  />
        </div>
    </div> */}
      </div>

    {/* <NewStudentForm /> */}

  <section className="py-5" style={{ background: "#eecfbbff" }}>
    <div className="container text-center mb-5">
        <div className="row g-4 pt-2">

            {/* <div className="col-md-6 offset-md-3">
                <Link href="https://www.shankariasacademy.com/pdf/SI-Test-Batch-2025/SI-STUDENTS-INSTRUCTIONS.pdf"
                 target="_blank"  
                >  
                   <span style={{ color: "#db1913ff", fontSize: "19px", textAlign:"center" }}><Image src={NewiconA} alt="download icon" width={50} height={50}  className={`${styles.downloadicon}`}/> Download Students Instructions  </span>
                </Link>
            </div> */}
            
               {/* <div className="col-md-6 offset-md-3">
                <Link href="/hallticket"
                 target="_blank"  
                >  
                   <span style={{ color: "#db1913ff", fontSize: "19px", textAlign:"center" }}> Hallticket Download </span>
                </Link>
            </div> */}
            </div>
</div>
   
</section>
  <section className="py-5" style={{ background: "#f2f6ff" }}>
      <div className="container text-center">

        <h2 className={`${styles.contactheader} text-center `} style={{ color: "#0B1F3A" }}>
          TNUSRB SI Mock Test Schedule
        </h2>

        <hr className="mx-auto mb-5"
          style={{ width: "100px", border: "2px solid #D4AF37", borderRadius: "3px" }}
        />

        <div className="row g-4 justify-content-center">
          {data.map((item, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-3">
              <div
                className="p-4 text-white rounded-4 d-flex flex-column align-items-center"
                style={{
                  background: "linear-gradient(160deg, #0B1F3A, #062045)",
                  border: `2px solid #D4AF37`,
                  paddingTop: "60px",
                  position: "relative",
                }}
              >
                
                <div
                  style={{
                    position: "absolute",
                    top: "-25px",
                    background: "#0B1F3A",
                    border: "2px solid #D4AF37",
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <PoliceCap />
                </div>

                <h5 className="fw-bold mt-4" style={{ color: "#D4AF37" }}>{item.title}</h5>
                <p style={{ color: "#fff", fontSize: "0.95rem" }}>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <div className="container-fluid p-0" style={{ background: "#F9FAFB" }}>

    <section className="py-2">
        <div className="container">
            <h2 className={`${styles.contactheader} text-center `}>Mode of Examination</h2>
            <div className="row justify-content-center ">
                <div className="col-10 col-md-6">
                <div className="p-4 rounded-4 shadow-sm bg-white">
                    <h4 className=" text-center">Only <span className="text-success">Offline</span></h4>
                    <p className="text-muted mt-2 mb-0">Choose your preferred mode and experience the real TNPSC Mains environment.</p>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section className="py-5" style={{ background: "#F9FAFB" }}>
        <div className="container">
            <h2 className={`${styles.contactheader} text-center mb-4`}>Important Dates</h2>

            <div className="row g-4 justify-content-center">
            {[
                { title: "Registration Opening Date", date: "9th November 2025", icon: "bi-calendar-check" },
                { title: "Registration Closing Date", date: "9th December 2025", icon: "bi-calendar-x" },
                { title: "Hall Ticket Download", date: "12th December 2025 at 5:00 PM", icon: "bi-ticket-perforated" },
                { title: "Result Publication (Tentative)", date: "15th December 2025 at 6:00 PM", icon: "bi-megaphone" },
            ].map((item, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-5">
                <div className="card border-0 shadow-sm rounded-4 h-100 p-3" style={{ background: "#fff" }}>
                    <div className="d-flex align-items-center mb-2">
                    <i className={`bi ${item.icon} text-primary fs-3 me-3`}></i>
                    <h5 className="fw-bold text-dark mb-0">{item.title}</h5>
                    </div>
                    <p className="text-muted fs-6 ps-5">{item.date}</p>
                </div>
                </div>
            ))}
            </div>
        </div>
    </section>

    <section className="py-5" style={{ background: "#E9EEF3" }}>
      <div className="container">
            <h2 className={`${styles.contactheader}  mb-2`}>Features of the Mock Test</h2>
            <div className="row ">
                <div className="col-12 col-md-10 col-lg-8">
                <ul className="list-group list-group-flush bg-transparent">
                    {[
                    "Real Simulation of TNUSRB SI Written Examination conducted by TNUSRB",
                    "Reflection making Mock Test",
                    "Release of Rank list",
                   
                    ].map((text, i) => (
                    <li key={i} className="list-group-item bg-transparent border-0 fs-5 py-2">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>{text}
                    </li>
                    ))}
                </ul>
                </div>
            </div>

            {/*<div className="alert alert-warning mt-4" role="alert">
                <h5 className="fw-bold text-dark mb-2">Note<sup className= {`${styles.dot}`}>*</sup></h5>
                <p className="mb-0">
                     Written Answer Scripts will not be given/shared to students for any reason after evaluation and our evaluation is final.
                </p>
            </div> */}
            
      </div>      
    </section>

    </div>

    <section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
          <div className="container"> 
              <div className={`${styles.head}  pt-2 pb-2`}>
                <h3>State Level TNUSRB SI Mock Test 2025 - Venue</h3>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4 col-12 mb-3">
                  <div className={`${styles.contactbox} h-100 `}>
                    <div className="row pt-3 pb-3">
                          <div className= {`${styles.addbox} px-4 pt-2`}>
                              <span>Shankar IAS Academy, Admission Office</span>
                              <p >Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040. <br/>Contact: 76677 66266</p>
                         </div>

                        
                    </div>
                 </div>
               </div>

               <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Shankar IAS Academy (Celestial Place)</span>
                                  <p>No. 255 , AL Block , 4th Avenue, Shanthi colony, Anna Nagar, Chennai - 600 040.<br/>Contact: 044-43533445 | 044-45543082</p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Chennai - ADYAR </span>
                                  <p >SHANKAR IAS ACADEMY , No-2/23, 3rd Cross Street, Padmanabhanagar, (Opposite to Sishya School), Adyar,  Chennai-600 020</p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Thiruvarur</span>
                                  <p>Shankar IAS Academy, 3/310/7 GTN Complex, Mannai salai, (Opp to State Bank of India), Vilamal,<br/> Thiruvarur-610 001. <br/>
                                   Contact: 97877 34943 | 70102 62725 | 9787734943</p>
                              </div>
                          </div>
                    </div>
                </div>

               

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Madurai</span>
                                <p>Shankar IAS Academy, 5th Floor, Bata Show Room, GSP Plaza, Anna Nagar, Madurai-625020.<br/>
                                    Contact: 97896-22555</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                              <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Salem</span>
                                <p>Shankar IAS Academy, NO.207/5, United Arcade, Kavery Avenue, State Bank Colony, Salem 636004.<br/>
                                  Contact: 0427-2441961 / 8940080039</p>
                              </div>

                          </div>
                       </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Trichy</span>
                                <p>Shankar IAS Academy, N.R.Towers, A9 (N),  Salai Road,  Thillai Nagar, Trichy-620018.
                                  Landmark: LIC -Rock Fort Branch Building <br/>
                                  Contact : 97896 64555 / 0431-4976911</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Namakkal</span>
                                <p>Shankar IAS Academy, Cheran Towers, Block No. 2/67, 1st floor West Thillaipuram Main Road, Paramathi Rd, Namakkal 637001</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>SHANKAR IAS ACADEMY, COIMBATORE.</span>
                                <p> 790, CROSS CUT ROAD, ZUDIO BUILDING, 3RD FLOOR, GANDHIPURAM, COIMBATORE. PIN - 641012. <br/>
                                  Contact:  0422-4380834 | 0422-4380835 | <br/> 94892 22761 | 87927 39577</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

              </div>
          </div>
        <br/>
        </section>

    <Footer />

    </>
  );
}




